
seedWebControllers.controller('MainController', ['$scope', '$rootScope', '$location', '$route', 'UserSettingService', 'moment', 'authService', 'CompanySettingService', '$cookies', 'TranslationService', '$window',
    function ($scope, $rootScope, $location, $route, UserSettingService, moment, authService, CompanySettingService, $cookies, TranslationService, $window) {
        //$scope.translation = TranslationService.getActiveTranslation();
        
        if (seedWebApp.buildVersion) {
            $scope.buildVersion = seedWebApp.buildVersion.replace('?v=', '');
        }
        console.log('Versao: ' + $scope.buildVersion);
        $scope.supportEmail = 'orders@millpar.com';

        //EVENTO USUARIO LOGADO
        $scope.$on('on_get_profile', function (event, email) {
            
            if (email) {
                $scope.UserID = email;
                $scope.LoggedUser = email;

                $rootScope.moduleName = 'Home';

                var companyID = localStorage.getItem('company_id');
                if (!companyID) {
                    companyID = 'GenesisAraupel';
                }

                $rootScope.LoggedCompanyID = companyID;

                $scope.LoggedCompanyID = companyID;
                $scope.setCompanyLayout(companyID);

                var tokenID = localStorage.getItem('id_token');
                var accessToken = localStorage.getItem('access_token');

                $cookies.put('token', tokenID);
                $cookies.put('access_token', accessToken);
                $cookies.put('company-id', companyID);              

                console.log('auth0.isAuthenticated: getUserSettings');
                //JRM - CARREGAR MODULOS APÓS
                if (authService.isAuthenticated())
                {
                    $scope.getUserSettings();
                    $scope.loadUserSettings(email);
                }
            }
            else {
                $scope.auth.logout();
            }
        });

        $scope.setCompanyLayout = function (companyID) {
            console.log('setCompanyLayout: ' + companyID);

            var sidebar = document.getElementById('sidebar-menu')
            var elVersion = document.getElementById('build-version');
            var newStyle;
            if (companyID == 'GenesisAraupelQua') {
                newStyle = 'qua-background';
                //sidebar.classList.add('qua-background');
            }
            else if (companyID == 'GenesisAraupelTests') {
                newStyle = 'tests-background';
                //sidebar.classList.add('tests-background');                
            }
            if (newStyle) {
                sidebar.classList.add(newStyle);
            }            
            if (elVersion) {
                elVersion.classList.add(newStyle);
            }

        };

        $scope.loadUserSettings = function (userID) {
            var invitation = $cookies.get('invitation');
            if (!invitation)
                invitation = '';
            $scope.UserType = '';
            $scope.loading = true;
            $scope.errorDescription = null;
            if (!userID) {
                $scope.loading = false;
                return;
            }
            UserSettingService.get({ id: userID, invitation: invitation }, function () {
                $cookies.remove('invitation');
            }, function (errorDescription) {
                $scope.errorDescription = errorDescription;
            });
        };

        $scope.closeInvError = function () {
            $scope.InvitationError = null;
        };

        $scope.selectModule = function (name) {
            $scope.selModule = name;
        };

        $scope.$on('$routeChangeSuccess', function (previous, current) {
            $scope.loadPage();
        });

        $scope.loadPage = function () {
            var current = $route.current;
            if (current && current.$$route && current.$$route.moduleName) {
                $scope.selModule = current.$$route.moduleName;
            }
            if ($scope.modules) {
                var allowed = false;
                var pathname = window.location.pathname;
                var count = pathname.split('/').length - 1;
                //console.log(pathname);
                if (pathname.includes('ContactDashboard') || pathname.includes('/Home/') || pathname.includes('/QuoteError/') || pathname.includes('/shippingDocs')) {
                    allowed = true;
                } else {
                    for (var i = 0; i < $scope.modules.length; i++) {
                        if (pathname.includes($scope.modules[i].name)) {
                            if ($scope.modules[i].pages && $scope.modules[i].pages.length > 0 && count > 2) {
                                for (var j = 0; j < $scope.modules[i].pages.length; j++) {
                                    if (pathname.includes($scope.modules[i].pages[j])) {
                                        allowed = true;
                                        break;
                                    }
                                }
                                break;
                            } else {
                                allowed = true;
                                break;
                            }
                        }
                    }
                }
                if (!allowed) {
                    console.log('loadPage.NotAllowed: ' + pathname);
                    $location.path('/' + $scope.modules[0].name + '/');
                }
                else {
                    console.log('loadPage.Allowed: ' + pathname);
                }
            }
            else {
                console.log('loadPage.NoModulesFound: ' + pathname);
            }
        };

        $scope.Login = function (companyID) {
            
            var expireDate = new Date();
            expireDate.setDate(expireDate.getDate() + 7);
            $cookies.put('LoggedIn', true);
            $scope.LoggedIn = $cookies.getObject('LoggedIn');
            $scope.auth.login(companyID);
        };

        $scope.Logout = function () {
            
            $cookies.remove('LoggedIn');
            $scope.auth.logout();
        };

        $scope.getUserSettings = function () {
            CompanySettingService.getUserSettings($scope);
            //StoreService.loadUser($scope, $scope.UserID);

            //CompanySettingService.action(
            //    { actionTag: 'ACTION_LOAD_USER_SETTINGS', parameters: '' },
            //    function (response) {
            //        $scope.selModule = $scope.moduleName;
            //        $scope.loggedUser = response.User;
            //        $scope.modules = response.Pages;
            //        $scope.loadPage();
            //    }, function () {
            //        authService.logout();
            //    });
        };

        $scope.AdjustSize = function (headerSize) {
            var innerHeight = Math.max(0, window.innerHeight);
            var sub = 88;
            if (headerSize) {
                sub = headerSize;
            }
            return innerHeight - sub;
        };

        // ----------------------------------------------------------------------------------------------------------------------
        // TRANSLATIONS
        // ----------------------------------------------------------------------------------------------------------------------
        $scope.translation = [];
        $scope.language = 'en'; //default english
        moment.locale($scope.language);

        TranslationService.getTranslation($scope, $scope.language);
        $scope.$watch('translation.$resolved == true', function () {
            if ($scope.translation.$resolved) {
                // Campos para formatação da data
                $scope.datePickerFormat = $scope.translation.DatePickerFormat;
                $scope.dateFormat = $scope.translation.DateFormat;
                $scope.dateAndTimeFormat = $scope.translation.DateAndTimeFormat;
                $scope.dateAndTimeAngularFormat = $scope.translation.DateAndTimeAngularFormat;
                $scope.timeFormat = $scope.translation.TimeFormat;
                $scope.pagesLoaded = true;
            }
        }, true);

        $scope.toggleLanguage = function (userLang) {
            console.log('toggleLanguage: ' + userLang);

            var lang = userLang || $scope.companyLanguage;
            if (lang && (lang === 'pt-br' || lang === 'en' || lang === 'es')) {
                $scope.language = lang;
            } else {
                $scope.language = 'pt-br';
            }
            //JRM: Forca recarregar paginas
            $scope.translation.$resolved = false;
            moment.locale($scope.language);
            TranslationService.getTranslation($scope, $scope.language);
        };

        $scope.setLanguage = function (lang) {
            //$scope.userSetting.UserLanguage = lang;
            $scope.appLanguage = lang;
            $scope.saveUserLanguage($scope.LoggedUser, lang);
            $scope.toggleLanguage(lang);
        };

        $scope.saveUserLanguage = function (userID, language) {
            var user = {
                UserID: userID,
                UserLanguage: language
            };
            UserSettingService.saveUserLanguage(user).then(function (result) {
                $scope.success = true;
                $scope.error = false;
            }, function (errorDescription) {
                $scope.success = false;
                $scope.error = true;
                $scope.errorDescription = errorDescription;
            });
        };

        $scope.isHomePage = function () {
            var path = $location.path();
            return path.indexOf('Home') > -1;
        };

        $scope.isMobile = $(window).width() < 600;

        angular.element($window).bind('resize', function () {

            $scope.isMobile = $(window).width() < 600;

            // manuall $digest required as resize event
            // is outside of angular
            $scope.$digest();
        });

        //$(document).ready(function () {
        //    google.charts.load('current', { 'packages': ['corechart', 'bar', 'calendar', 'gauge', 'line', 'orgchart', 'sankey', 'timeline', 'wordtree'] });
        //    console.log('Google Charts LOADED!');
        //    //AdjustMainSize();
        //    //window.addEventListener('resize', function () { AdjustMainSize(); }, true);
        //    //VerifyBrowser();
        //});

        $scope.verifyPermsAndDefineTabs = function (scope, type) {
            scope.pages = [];
            //console.log('verifyPerms');
            for (var i = 0; i < scope.defaultPages.length; i++) {
                if ($scope.displayTabs(scope.defaultPages[i].pageDisplay, type)) {
                    scope.pages.push(scope.defaultPages[i]);
                }
            }
            for (var j = 0; j < scope.pages.length; j++) {
                scope.pages[j].pageIndex = j;
            }
            if (scope.selTab && scope.pages[scope.selTab]) {
                $location.search('Tab', scope.selTab);
                scope.selectedIndex = scope.selTab;
            } else {
                if (scope.pages[0])
                {                
                    scope.selectedIndex = scope.pages[0].pageIndex;
                    //JRM: Seleciona apenas se maior que zero
                    if (scope.selectedIndex) {
                        $location.search('Tab', scope.pages[0].pageIndex)
                    }                
                }
            }
            
            scope.loadingTabs = false;
        };

        $scope.displayTabs = function (pageName, type) {

            if ($scope.modules) {
                for (var i = 0; i < $scope.modules.length; i++) {
                    if ($scope.modules[i].name.includes(type)) {
                        if ($scope.modules[i].pages.length > 0) {
                            for (var j = 0; j < $scope.modules[i].pages.length; j++) {
                                if (pageName == $scope.modules[i].pages[j]) {
                                    return true;
                                }
                            }
                        }
                        return false;
                    }
                }
            }
            return false;
        };

        $scope.getVersionPosition = function () {
            var pos = $(window).width();
            if (pos > 120) {
                pos = pos - 120;
            }
            pos = pos / 2;
            return pos + 'px';
        };

        $scope.getTranslation = function (text) {
            return $scope.translation[text] || text;
        };

        //DEBUG
        $rootScope.$on('$routeChangeStart', function (event, next, current) {
            // next is an object that is the route that we are starting to go to
            // current is an object that is the route where we are currently
            var currentPath;
            if (current) {
                currentPath = current.originalPath;
            }
            
            var nextPath = next.originalPath;

            console.log('Starting to leave %s to go to %s', currentPath, nextPath);
        });

    }]);